import React from 'react';
// styles
import styled from 'styled-components';

const DateIcon = ({ className, ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
    aria-label="Date"
    className={className}
  >
    <path
      d="M12.087 14.7501H11.2175C10.7372 14.7501 10.3479 15.1232 10.3479 15.5834C10.3479 16.0436 10.7372 16.4167 11.2175 16.4167H12.087C12.5673 16.4167 12.9566 16.0436 12.9566 15.5834C12.9566 15.1232 12.5673 14.7501 12.087 14.7501Z"
      fill="#94A6B8"
    />
    <path
      d="M16.4347 14.7501H15.5651C15.0849 14.7501 14.6956 15.1232 14.6956 15.5834C14.6956 16.0436 15.0849 16.4167 15.5651 16.4167H16.4347C16.9149 16.4167 17.3043 16.0436 17.3043 15.5834C17.3043 15.1232 16.9149 14.7501 16.4347 14.7501Z"
      fill="#94A6B8"
    />
    <path
      d="M20.7826 14.7501H19.913C19.4328 14.7501 19.0435 15.1232 19.0435 15.5834C19.0435 16.0436 19.4328 16.4167 19.913 16.4167H20.7826C21.2628 16.4167 21.6522 16.0436 21.6522 15.5834C21.6522 15.1232 21.2628 14.7501 20.7826 14.7501Z"
      fill="#94A6B8"
    />
    <path
      d="M12.087 18.0834H11.2175C10.7372 18.0834 10.3479 18.4565 10.3479 18.9167C10.3479 19.3769 10.7372 19.75 11.2175 19.75H12.087C12.5673 19.75 12.9566 19.3769 12.9566 18.9167C12.9566 18.4565 12.5673 18.0834 12.087 18.0834Z"
      fill="#94A6B8"
    />
    <path
      d="M16.4347 18.0834H15.5651C15.0849 18.0834 14.6956 18.4565 14.6956 18.9167C14.6956 19.3769 15.0849 19.75 15.5651 19.75H16.4347C16.9149 19.75 17.3043 19.3769 17.3043 18.9167C17.3043 18.4565 16.9149 18.0834 16.4347 18.0834Z"
      fill="#94A6B8"
    />
    <path
      d="M12.087 21.4167H11.2175C10.7372 21.4167 10.3479 21.7898 10.3479 22.2501C10.3479 22.7103 10.7372 23.0834 11.2175 23.0834H12.087C12.5673 23.0834 12.9566 22.7103 12.9566 22.2501C12.9566 21.7898 12.5673 21.4167 12.087 21.4167Z"
      fill="#94A6B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.8696 8.50006H24.2609C25.2214 8.50006 26 9.24625 26 10.1667V24.3334C26 25.2539 25.2214 26.0001 24.2609 26.0001H7.73913C6.77864 26.0001 6 25.2539 6 24.3334V10.1667C6 9.24625 6.77864 8.50006 7.73913 8.50006H9.04348C9.2836 8.50006 9.47826 8.68661 9.47826 8.91673V10.7917C9.47826 11.1369 9.77025 11.4167 10.1304 11.4167C10.4906 11.4167 10.7826 11.1369 10.7826 10.7917V6.83339C10.7826 6.37316 11.1719 6.00006 11.6522 6.00006C12.1324 6.00006 12.5217 6.37316 12.5217 6.83339V8.29256C12.5222 8.40729 12.6194 8.50006 12.7391 8.50006H18.1739C18.414 8.50006 18.6087 8.68661 18.6087 8.91673V10.7917C18.6087 11.1369 18.9007 11.4167 19.2609 11.4167C19.6211 11.4167 19.913 11.1369 19.913 10.7917V6.83339C19.913 6.37316 20.3024 6.00006 20.7826 6.00006C21.2629 6.00006 21.6522 6.37316 21.6522 6.83339V8.29173C21.6522 8.40679 21.7495 8.50006 21.8696 8.50006ZM23.8262 24.3334C24.0663 24.3334 24.261 24.1468 24.261 23.9167V13.9167C24.261 13.6866 24.0663 13.5001 23.8262 13.5001H8.174C7.93387 13.5001 7.73922 13.6866 7.73922 13.9167V23.9167C7.73922 24.1468 7.93387 24.3334 8.174 24.3334H23.8262Z"
      fill="#94A6B8"
    />
  </svg>
);

export default styled(DateIcon)``;
